import { Flex, Skeleton } from "antd";

const RecapSummarySkeleton = () => {
  return (
    <Flex className="mt-4" vertical style={{ width: "100%" }} gap={6}>
      <Flex gap={6}>
        <Skeleton.Button active shape={"round"} style={{ width: "100px" }} />
        <Skeleton.Button active shape={"round"} style={{ width: "100px" }} />
      </Flex>
      <Skeleton active paragraph={{ rows: 4 }} />
    </Flex>
  );
};

export default RecapSummarySkeleton;
